export enum SubscribeSimplifiedModalTypeEnum {
  ACCESS_RESULTS = 'ACCESS_RESULTS',
  NOT_PROFESSIONAL_EMAIL = 'NOT_PROFESSIONAL_EMAIL',
}
